import type { LoginRequest, LoginResponse, Me } from '@turnpilot/contracts';

/** Appels d'API du client web (même origine, cookie de session HttpOnly). */
export async function fetchMe(): Promise<Me | null> {
  const r = await fetch('/api/v1/me', { credentials: 'same-origin' });
  if (r.status === 401) return null;
  if (!r.ok) throw new Error(`/api/v1/me : ${r.status}`);
  return (await r.json()) as Me;
}

export type LoginResult = LoginResponse | { step: 'error'; error: string };

export async function login(body: LoginRequest): Promise<LoginResult> {
  const r = await fetch('/api/v1/auth/login', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = (await r.json().catch(() => ({}))) as { error?: string };
  if (!r.ok) return { step: 'error', error: json.error ?? `http_${r.status}` };
  return json as LoginResponse;
}

export async function logout(): Promise<void> {
  await fetch('/api/v1/auth/logout', { method: 'POST', credentials: 'same-origin' });
}
